import ErrorCardContent from './ErrorCardContent'
export default ErrorCardContent
